import { useLayoutEffect, useRef, useState } from 'react';
import Icon from 'components/icon/Icon';
import { Button } from 'components/button';

const AddButton = ({ label, expandable, onClick }) => {
  return expandable ? (
    <ExpandableButton label={label} onClick={onClick} />
  ) : (
    <Button rounded primary onClick={() => onClick()}>
      <Icon id="add-white" />
      {label}
    </Button>
  );
};

const ExpandableButton = ({ ...props }) => {
  const [labelWidth, setLabelWidth] = useState(32);
  const [hoverOn, setHoverOn] = useState(false);
  const labelRef = useRef();

  useLayoutEffect(() => {
    if (!!labelRef?.current) {
      setLabelWidth(
        Math.ceil(labelRef?.current?.getBoundingClientRect().width) + 48
      );
    }
  }, [labelRef]);

  return (
    <div
      style={{
        width: hoverOn ? labelWidth : 32,
        position: 'absolute',
        height: 32,
        right: 36,
        transition: 'width .2s ease-in-out'
      }}
    >
      <Button
        extraClassNames={'c-button--icon-expandable'}
        rounded
        primary
        onClick={() => props.onClick()}
        onMouseEnter={() => setHoverOn(true)}
        onFocus={() => setHoverOn(true)}
        onMouseLeave={() => setHoverOn(false)}
        onBlur={() => setHoverOn(false)}
      >
        <Icon id="add-white" />
        <span className="c-button__label" ref={labelRef}>
          {props.label}
        </span>
      </Button>
    </div>
  );
};

export default AddButton;
